import script from "./WidgetBreadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetBreadcrumbs.vue?vue&type=script&setup=true&lang=js"

import "./WidgetBreadcrumbs.vue?vue&type=style&index=0&id=ffd3cbb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd3cbb4"]])

export default __exports__